import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* chargeTypeUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_CLEAR,
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_REQUEST
    });

    yield call(Http.put, `charge-type/${action.payload?.chargeType.id}`, {
      label: action.payload?.chargeType.label,
      removed: action.payload?.chargeType.removed,
    });

    const dataTypes = yield call(Http.get, "data-labels");

    yield put({
      type: Constants.GLOBAL_RECEIVE_DATA_TYPES_LIST_SUCCESS,
      payload: dataTypes.data
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-type-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_TYPE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeTypeUpdate() {
  yield takeEvery(Constants.GLOBAL_CHARGE_TYPE_UPDATE_START, chargeTypeUpdate);
}
